import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
  name: 'overlay',
  initialState: {
    isPlayerOverlayVisible: false,
    overlayPlayerIdx: 0,
    buyingCard: null,
    alertData: null,
    yieldStatus: null
  },
  reducers: {
    togglePlayerOverlayShowing: state => {
      state.isPlayerOverlayVisible = !state.isPlayerOverlayVisible;
    },
    setOverlayPlayerIdx: (state, { payload }) => {
      state.overlayPlayerIdx = payload;
    },
    setOverlayBuyingCard: (state, { payload }) => {
      state.buyingCard = payload;
    },
    showAlert: (state, { payload }) => {
      state.alertData = payload;
    },
    clearAlert: state => {
      state.alertData = null;
    },
    setYieldStatus: (state, { payload }) => {
      state.yieldStatus = payload;
      state.yieldStatus.end = Date.now() + payload.duration;
    },
  },
});

export const { togglePlayerOverlayShowing, setOverlayPlayerIdx, setOverlayBuyingCard, showAlert, clearAlert, setYieldStatus } = slice.actions;

export const selectIsOverlayShowing = state => state.overlay.isPlayerOverlayVisible;
export const selectOverlayPlayer = state => state.game.players.find((player) => player.id === state.overlay.overlayPlayerIdx);
export const selectOverlayBuyingCard = state => state.overlay.buyingCard;
export const selectAlertOverlayData = state => state.overlay.alertData;
export const selectYieldStatus = state => state.overlay.yieldStatus;
export default slice.reducer;
